import { useLayoutEffect } from 'react';
import { runRecalculateSubscribers } from '@atlassian/jira-software-fast-virtual';
import { useBacklogSelector } from '../../state';
import {
	getCollapsedCardLists,
	getOrderedCardListIds,
	getOrderedCardIdsByCardListId,
	getCardListCount,
} from '../../state/selectors/cards';

export const SyncFastVirtualSubscribers = () => {
	// track card lists being expanded and collapsed
	const collapsedCardLists = useBacklogSelector(getCollapsedCardLists);

	// track sprint containers being created and deleted
	const cardListCount = useBacklogSelector(getCardListCount);

	// track sprint containers moving up and down from ... menu
	const cardListOrder = useBacklogSelector(getOrderedCardListIds);

	// track cards moving up and down by draggable divider
	const cardOrder = useBacklogSelector(getOrderedCardIdsByCardListId);

	useLayoutEffect(() => {
		runRecalculateSubscribers();
	}, [collapsedCardLists, cardListCount, cardListOrder, cardOrder]);

	return null;
};

export default SyncFastVirtualSubscribers;
